import { TextChannelKey } from 'types'
import { AspectRatioKey } from 'components/NewFileModal/Types'
import { GROUPS } from './constants'
import { useMemo } from 'react'
import { Group } from './Types'

export const filterGroups = (hiddenKeys: Set<TextChannelKey | AspectRatioKey>, groups = GROUPS) => {
  return groups
    .map((group) => {
      const filteredGroup = { ...group }
      filteredGroup.channels = group.channels.filter((channel) => {
        return !hiddenKeys.has(channel)
      })

      if (filteredGroup.channels.length === 0) {
        return null
      }
      return filteredGroup
    })
    .filter(Boolean) as Group[]
}

export const useGroups = (hiddenKeys?: Set<TextChannelKey | AspectRatioKey>) => {
  return useMemo(() => {
    if (!hiddenKeys) {
      return GROUPS
    }

    return filterGroups(hiddenKeys)
  }, [hiddenKeys])
}
